// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__KrcMN","content":"LayoutSettings_content__kPnVJ"};